import { Dialog } from "primereact/dialog";
import TextareaField from "../../components/TextareaField/TextareaField";
import TextField from "../../components/Textfield/TextField";
import { useRef, useState } from "react";
import { UserWallet } from "../../services/services";
import { Toast } from "primereact/toast";

const ModalSendCoin = ({
  showModalSendCoin,
  setShowModalSendCoin,
  userIdList,
}) => {
  const [sendCoin, setSendCoin] = useState({
    Amount: undefined, // 👈 undefined به‌جای 0
    Description: "",
  });
  const toast = useRef(null);

  const handleHide = () => {
    setShowModalSendCoin(false);
    setSendCoin({ Amount: undefined, Description: "" });
  };

  const isDisabled =
    sendCoin?.Amount == null ||
    isNaN(sendCoin.Amount) ||
    sendCoin?.Description.trim() === "";

  const handleSubmit = () => {
    const amountNumber = Number(sendCoin.Amount);

    if (isNaN(amountNumber)) {
      toast.current?.show({
        severity: "warn",
        summary: "خطا",
        detail: "لطفا مقدار سکه را به‌درستی وارد کنید",
        life: 3000,
      });
      return;
    }

    UserWallet({
      Amount: amountNumber,
      Description: sendCoin.Description,
      UserId: userIdList[0],
      CurrencyId: 1,
    }).then(() => {
      toast.current?.show({
        severity: "success",
        summary: "موفق",
        detail: "سکه ارسال شد",
        life: 4000,
      });
      handleHide();
    });
  };

  const handleAmountChange = (e) => {
    let value = e.target.value;

    if (value === "") {
      setSendCoin({ ...sendCoin, Amount: undefined });
      return;
    }

    const numeric = Number(value);

    setSendCoin({
      ...sendCoin,
      Amount: numeric, // 👈 عدد داخل state
    });
  };

  return (
    <Dialog
      header={``}
      visible={showModalSendCoin}
      style={{ width: "20vw", height: "16vw" }}
      maximizable
      modal
      contentStyle={{ height: "300px", overflowX: "hidden" }}
      onHide={handleHide}
      className="farsi-monospace-digit custom-dialog"
    >
      <Toast ref={toast} position="top-center" />

      <div className="row justify-content-center mx-4 mt-4">
        <TextField
          style={{ height: "40px" }}
          type="number" // 👈 type عددی (می‌تونی tel هم بذاری، مهم هندل کردن ورودی است)
          value={sendCoin.Amount ?? ""} // 👈 برای جلوگیری از warning
          label={"سکه"}
          onChange={handleAmountChange}
        />

        <TextareaField
          value={sendCoin.Description}
          classNameBox="mt-4 "
          label="متن پیام"
          onChange={(e) =>
            setSendCoin({ ...sendCoin, Description: e.target.value })
          }
        />

        <button
          style={{
            color: "#ffffff",
            background: "#86a0ff",
            border: 0,
            width: "68px",
            borderRadius: "8px",
            padding: "4px 0",
            marginTop: "20px",
            cursor: isDisabled ? "not-allowed" : "pointer",
            opacity: isDisabled ? 0.5 : 1,
          }}
          onClick={handleSubmit}
          disabled={isDisabled}
        >
          ثبت
        </button>
      </div>
    </Dialog>
  );
};

export default ModalSendCoin;
